export default __webpack_public_path__ + "static/media/intro-start.428086b4.png";